import React from 'react';

import BannerDw from './BannerDw';
import ConciergeGeneric from '@components/Messaging/ConciergeGeneric';

import scss from './SideBar.module.scss';
import { useVwp } from '../VwpContext';

const SideBar = () => {
  const { userDetails, onLoggedIn } = useVwp();
  
  return (
    <div className={scss.sideBar}>
      <div className={scss.sideBarContainer}>
        <ConciergeGeneric
          name={!!userDetails ? userDetails.FirstName : ''}
          userId={(!!userDetails && !!userDetails.UserId) ? userDetails.UserId : ''}
          isConciergeChannelCreated={!!userDetails ? !!userDetails.IsConciergeChannelCreated : false}
          isOnDashboard={false}
          staticVersion={true}
          onLoggedIn={onLoggedIn}
        />
        <BannerDw />
      </div>
    </div>
  );
}
export default SideBar;
